import { render, staticRenderFns } from "./security_admin_dashboard.vue?vue&type=template&id=1a5d683e&scoped=true"
import script from "./security_admin_dashboard.vue?vue&type=script&lang=js"
export * from "./security_admin_dashboard.vue?vue&type=script&lang=js"
import style0 from "./security_admin_dashboard.vue?vue&type=style&index=0&id=1a5d683e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5d683e",
  null
  
)

export default component.exports